// Lista de bancos
export const BANKS_OPTIONS = [
	{ value: "0102", label: "0102 - Banco de Venezuela" },
	{ value: "0104", label: "0104 - Venezolano de Crédito" },
	{ value: "0105", label: "0105 - Banco Mercantil" },
	{ value: "0108", label: "0108 - Banco Provincial" },
	{ value: "0114", label: "0114 - Banco Bicentenario del Pueblo" },
	{ value: "0115", label: "0115 - Banco Exterior" },
	{ value: "0116", label: "0116 - Banco Occidental de Descuento" },
	{ value: "0128", label: "0128 - Banco Caroní" },
	{ value: "0134", label: "0134 - Banco Banesco" },
	{ value: "0137", label: "0137 - Banco Sofitasa" },
	{ value: "0138", label: "0138 - Banco Plaza" },
	{ value: "0146", label: "0146 - Banco de la Gente Emprendedora (Bangente)" },
	{ value: "0149", label: "0149 - Banco del Pueblo Soberano" },
	{ value: "0151", label: "0151 - BFC Banco Fondo Común" },
	{ value: "0156", label: "0156 - 100% Banco" },
	{ value: "0157", label: "0157 - Banco Del Sur" },
	{ value: "0163", label: "0163 - Banco del Tesoro" },
	{ value: "0166", label: "0166 - Banco Agrícola de Venezuela" },
	{ value: "0168", label: "0168 - Bancrecer" },
	{ value: "0169", label: "0169 - Mi Banco" },
	{ value: "0171", label: "0171 - Banco Activo" },
	{ value: "0172", label: "0172 - Bancamiga" },
	{ value: "0173", label: "0173 - Banco Internacional de Desarrollo" },
	{ value: "0174", label: "0174 - Banplus" },
	{ value: "0175", label: "0175 - Banco Bicentenario del Pueblo" },
	{ value: "0176", label: "0176 - Novo Banco" },
	{
		value: "0177",
		label: "0177 - Banco de la Fuerza Armada Nacional Bolivariana (BANFANB)",
	},
	{ value: "0190", label: "0190 - Citibank" },
	{ value: "0191", label: "0191 - Banco Nacional de Crédito (BNC)" },
];
